<template>
    <div class="savings-tips">
        <h3>{{ savingsTip.heading }}</h3>
        <p>{{ savingsTip.text }}</p>
        <p><router-link to="/main/all-tips">View all</router-link></p>
    </div>
</template>
<script>
import {randomChoice} from '../fakeData.js'
export default {
    name: 'SavingsTips',
    data() {
        return {
            tips: [],
            savingsTip: {
                heading: '',
                text: '',
            },
        }
    },
    methods: {
        async getTips() {
            let r = await fetch('https://fisential.com/fake-data/tips.json')
            let data = await r.json()

            this.savingsTip = randomChoice(data)
        },
    },
    created () {
        this.getTips()
    }
}
</script>
<style lang="scss">
.savings-tips {
    background: #40D3FF;
    padding: 16px;

    h3 {
        font-size: 16px;
        font-weight: bold;
        text-align: left;
        margin-bottom: 13px;
    }

    p {
        font-size: 13px;
        text-align: left;
    }

    a {
        color: black;
    }
}
</style>
